import e from "./index13.js";
//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/capitalize/capitalize.js
function t(t) {
	if (typeof t != "string") throw Error(process.env.NODE_ENV === "production" ? e(7) : "MUI: `capitalize(string)` expects a string argument.");
	return t.charAt(0).toUpperCase() + t.slice(1);
}
//#endregion
export { t as default };

//# sourceMappingURL=index34.js.map